module.exports = "https://assets.bwbx.io/s3/reg2/images/account-tooltip-cds-20b3c9d8dc0ba2650de9.png";